"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.challengeInGameDistribution = void 0;
exports.challengeInGameDistribution = {
    popupTitle: 'Congratulations! Here is your Reward:',
    popupStyle: {
        color: 'ffffff',
        backgroundColor: '000000',
        textAlign: 'center',
        fontSize: '16px',
    },
    codeStyle: {
        color: 'ffffff',
        backgroundColor: 'cccccc',
        fontSize: '24px',
    },
    buttonText: 'GO TO OUR WEBSITE',
    buttonStyle: {
        color: 'ffffff',
        backgroundColor: 'cccccc',
        fontSize: '24px',
    },
};
